import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { CreateRateDto, RateDto } from "libs/dto/src/rate";

const createRate = async (data: CreateRateDto) => {
  const response = await axios.post<RateDto, AxiosResponse<RateDto>>("rates/", data);
  return response.data;
};

export const useCreateRate = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: createRateFn,
  } = useMutation({
    mutationFn: createRate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-rate"] });
    },
  });

  return { createRate: createRateFn, error, loading };
};
